var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M6.4343.8343a.8.8 0 011.1314 0l5.6 5.6a.8163.8163 0 01.0831.0975A.7984.7984 0 0113.4 7l-.004-.0809a.8046.8046 0 01.0035.0522L13.4 7a.8142.8142 0 01-.0113.135.7955.7955 0 01-.223.4306l.0675-.0766a.8045.8045 0 01-.06.0692l-.0075.0075-5.6 5.6a.8.8 0 11-1.1314-1.1314L10.668 7.8H1.4a.8001.8001 0 01-.7938-.6996L.6 7a.8.8 0 01.8-.8h9.268L6.4343 1.9657A.8002.8002 0 016.357.924z"}));
}

ArrowRightInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
